import { ProfileInfo } from './../../shared/models/profile-info';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { WizardStore } from '../stores/wizard-store.service';

@Component({
  selector: 'app-list-candidates',
  templateUrl: './list-candidates.component.html',
  styleUrls: ['./list-candidates.component.scss']
})
export class ListCandidatesComponent implements OnInit, OnDestroy {
  @Input() showOnlyHiredCandidate: string;
  candidateProfileInfos: ProfileInfo[] = [];
  constructor(public wizardStore: WizardStore) { }

  selectedCandidate: string;
  private subscriptions: Subscription[] = [];

  ngOnInit(): void {
    this.subscriptions.push(
      this.wizardStore.applicantProfileInfos.subscribe(resp => {
        this.candidateProfileInfos = this.showOnlyHiredCandidate ? resp.filter(x => {
          return x.progressStatus.toLocaleLowerCase() === "hired" || x.progressStatus.toLocaleLowerCase() === "finished"
        }) : resp;
      })
    );

    this.subscriptions.push(
      this.wizardStore.selectedCandidateAccountId.subscribe(s => {
        this.selectedCandidate = s;
      }));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe);
  }

  onCandidateSelected(candidateAccountId: string): void {
    this.wizardStore.inviteCandidate(candidateAccountId).then();
  }

  onViewProfileClicked(resumeId: string): boolean {
    window.open(`/view-candidate/${resumeId}`);
    return false;
  }

  getPhotoPath(candidate: ProfileInfo): string {
    if(!candidate.photoPath) {
      return "assets/images/avatar/04.jpg";
    }

    return candidate.photoPath;
  }

}
